import request from '@/utils/request'

export function getParkingName (parkId) {
  return request({
    method: 'get', url: '/noPlateNumber/getParkingName/' + parkId
  })
}

export function confirmIn (data) {
  return request({
    method: 'post',
    url: '/noPlateNumber/confirmIn',
    data
  })
}
